var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgHeliumHealthLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1773.06 239.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.5;}.cls-2{fill:#00308e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "65.74 94.47 65.74 0 0 0 0 239.83 65.74 239.83 65.74 141.46 65.74 94.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "174.09 0 174.09 94.47 174.09 141.46 174.09 239.83 239.83 239.83 239.83 0 174.09 0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.27,88.14a70.16,70.16,0,0,1,8.28,2l7.55,1.7c4.87,1,9.49,1.95,13.87,2.68a231.4,231.4,0,0,0,23.38,2.68,333.78,333.78,0,0,0,38.22,0c12.67-.73,25.33-2,38-3.9,7.79-1.22,15.34-2.92,23.13-4.87,4.38-1,8.52-2.43,13.39-3.89l7.3-2.44a78.91,78.91,0,0,1,8-2.68c4.87,20.46-4.87,41.15-21.67,56.25S145.84,160,121.5,160.94s-49.19-5.36-67.45-19a75.36,75.36,0,0,1-21.42-24.11,59.83,59.83,0,0,1-5.36-14.36v-.07A40.64,40.64,0,0,1,27,91.1C27.08,90.09,27.17,89.09,27.27,88.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M461,201.91H425.9V129H357.56v72.9H322.51V31.81h35.05v68.93H425.9V31.81H461Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M543.93,204.25q-27.81,0-45.27-17.06t-17.47-45.44v-3.27q0-19,7.36-34.06a54,54,0,0,1,20.86-23.13q13.48-8.12,30.78-8.12,25.93,0,40.83,16.35t14.9,46.39v13.78h-80.5q1.64,12.39,9.88,19.86T546.15,177q19.51,0,30.49-14.14l16.59,18.58a50.72,50.72,0,0,1-20.56,16.76A67.51,67.51,0,0,1,543.93,204.25Zm-3.86-103.86q-10.05,0-16.29,6.81t-8,19.48h47V124q-.24-11.26-6.08-17.43T540.07,100.39Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M647.12,201.91H613.24V22.47h33.88Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M665.83,42.79a16.65,16.65,0,0,1,5.08-12.5q5.08-4.91,13.85-4.9t13.78,4.9a16.52,16.52,0,0,1,5.14,12.5,16.59,16.59,0,0,1-5.19,12.62q-5.21,4.91-13.73,4.91T671,55.41A16.57,16.57,0,0,1,665.83,42.79ZM701.7,201.91H667.82V75.5H701.7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M798.94,189.06q-12.51,15.19-34.58,15.19-20.33,0-31-11.68t-10.92-34.23V75.5h33.76v81.76q0,19.77,18,19.77,17.18,0,23.6-11.93V75.5h33.88V201.91H799.87Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M884,75.5l1,14.14q13.43-16.47,36.33-16.47,24.42,0,33.53,19.27,13.32-19.27,38-19.27,20.57,0,30.61,12t10,36v80.73H999.66V121.3q0-10.74-4.21-15.71t-14.84-5q-15.18,0-21,14.49l.12,86.8H925.94V121.42q0-11-4.32-15.89t-14.72-4.91q-14.39,0-20.8,11.92v89.37H852.34V75.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1254.74,201.91h-35V129h-68.34v72.9h-35V31.81h35v68.93h68.34V31.81h35Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1337.72,204.25q-27.81,0-45.27-17.06T1275,141.75v-3.27q0-19,7.36-34.06a54,54,0,0,1,20.85-23.13q13.5-8.12,30.79-8.12,25.93,0,40.83,16.35t14.9,46.39v13.78h-80.5q1.63,12.39,9.87,19.86t20.86,7.48q19.5,0,30.49-14.14L1387,181.47a50.72,50.72,0,0,1-20.56,16.76A67.51,67.51,0,0,1,1337.72,204.25Zm-3.86-103.86q-10,0-16.3,6.81t-8,19.48h47V124q-.24-11.26-6.08-17.43T1333.86,100.39Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1480.4,201.91a37.38,37.38,0,0,1-3.39-11.33q-12.27,13.66-31.89,13.67-18.58,0-30.79-10.75a34.56,34.56,0,0,1-12.21-27.1q0-20.1,14.9-30.84t43-10.87h15.54v-7.24q0-8.78-4.5-14t-14.2-5.26q-8.52,0-13.37,4.09t-4.85,11.21h-33.76a33.87,33.87,0,0,1,6.77-20.32q6.78-9.34,19.16-14.67a69.93,69.93,0,0,1,27.81-5.31q23.36,0,37.09,11.74t13.73,33v54.8q.1,18,5,27.22v2Zm-27.93-23.48a29.06,29.06,0,0,0,13.79-3.33,21.88,21.88,0,0,0,9.35-8.94V144.43H1463q-25.35,0-27,17.53l-.11,2a13.5,13.5,0,0,0,4.43,10.4C1443.28,177.07,1447.34,178.43,1452.47,178.43Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1563.89,201.91H1530V22.47h33.88Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1628.53,44.43V75.5h21.61v24.77h-21.61v63.09q0,7,2.68,10t10.28,3a54.51,54.51,0,0,0,9.94-.81v25.58a69.38,69.38,0,0,1-20.45,3q-35.52,0-36.21-35.87V100.27h-18.46V75.5h18.46V44.43Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1697.59,89.29q13.42-16.12,33.76-16.12,41.12,0,41.71,47.78v81h-33.77v-80q0-10.86-4.67-16.06t-15.54-5.2q-14.83,0-21.49,11.45v89.84h-33.77V22.47h33.77Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeliumHealthLogo);
export default __webpack_public_path__ + "static/media/helium-health-logo.b7461ff21e8ac2acdd5694b662eb8d68.svg";
export { ForwardRef as ReactComponent };